const formatError = (error) => {
    const err = error.response?.data || error;
    const status = error.response?.status || '';
    let { name = '', message = '', description = '', ...rest } = err;

    return { status, name, message, description, rest };
};

export { formatError };
